
export const API_INFO = 'API_INFO'
export const APP_LOADING = 'APP_LOADING'
export const APP_FAILURE = 'APP_FAILURE'
export const API_USER_INFO = 'API_USER_INFO'
export const APP_USER_FAILURE = 'APP_USER_FAILURE'
export const API_OPENID_INFO = 'API_OPENID_INFO'
export const APP_OPENID_FAILURE = 'APP_OPENID_FAILURE'
export const API_ISBIND_INFO = 'API_ISBIND_INFO'
export const APP_ISBIND_FAILURE = 'APP_ISBIND_FAILURE'
export const API_MSGCODE_INFO = 'API_MSGCODE_INFO'
export const APP_MSGCODE_FAILURE = 'APP_MSGCODE_FAILURE'
export const API_REGISTER_INFO = 'API_REGISTER_INFO'
export const APP_REGISTER_FAILURE = 'APP_REGISTER_FAILURE'
export const API_SUBMIT_INFO = 'API_SUBMIT_INFO'
export const APP_SUBMIT_FAILURE = 'APP_SUBMIT_FAILURE'
export const API_GETRP_INFO = 'API_SUBMIT_INFO'
export const APP_GETRP_FAILURE = 'APP_SUBMIT_FAILURE'
export const API_TIME_INFO = 'API_TIME_INFO'
export const APP_TIME_FAILURE = 'APP_TIME_FAILURE'
export const API_BIND_INFO = 'API_BIND_INFO'
export const APP_BIND_FAILURE = 'APP_BIND_FAILURE'
export const API_LOGIN_INFO = 'API_LOGIN_INFO'
export const APP_LOGIN_FAILURE = 'APP_LOGIN_FAILURE'
export const API_MOBILE_LOGIN_INFO = 'API_MOBILE_LOGIN_INFO'
export const APP_MOBILE_LOGIN_FAILURE = 'APP_MOBILE_LOGIN_FAILURE'
export const API_FORGETCODE_INFO = 'API_FORGETCODE_INFO'
export const APP_FORGETCODE_FAILURE = 'APP_FORGETCODE_FAILURE'
export const API_RESETPWD_INFO = 'API_RESETPWD_INFO'
export const APP_RESETPWD_FAILURE = 'APP_RESETPWD_FAILURE'
export const APP_WX_SHARE                     = 'APP_WX_SHARE'



// album
export const ALBUM_PAGES                          = 'ALBUM_PAGES';
export const ALBUM_SERIES                          = 'ALBUM_SERIES';



// WEBPACK FOOTER //
// ./src/config/mutation-types.js